import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Large, H3 } from '../../../components/common/text';
import {
  FeedbackIcon,
  TermsCondition,
  NotificationIcon,
  AccountLanguage
} from '../../../components/common/icons';

import { LoadingCircle } from '../../../components/common/loading';
import styles from '../profile.styles';
import BlurModal from '../../../components/common/blur-modal';
import Button from '../../../components/common/button';
import Text,{H1} from '@dbk/ui-text';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import {
  Protect,
  Presentation,
  ChangePassword,
  ManageConsolidatedView,
  SelectCurrency,
  Contract,
  ManageDevices,
  ContactIcon,
  GoPaperless
} from '@dbk/ui-icons';
import LastLoginHeader from './profile-page-header';
import format from 'date-fns/format';
import { ROUTES, EBANKINGWEB, PALETTE, RM_REGION_CH, KEY_CODE } from '../../../constants';
import envConfig from '../../../../db-env-build';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';

class ProfileItem extends PureComponent {

  renderStars() {
    const { screen, stars, handleStarChange } = this.props;

    const blockItem = classNames('block-item-profile', {
      'block-item-profile-mobile': screen.isSmall,
    });
    const options = stars.options;

    return (
      <div className={blockItem}>
        {options.map((item, index) =>
          <div key={index}>
            <input
              type="checkbox"
              checked={item.isChecked}
              onChange={(e) => handleStarChange(e, item)}
              name="rating"
              value="value"
              id="rating"
            />
            <label />
          </div>
        )}
      </div>
    );
  }

  assetItem = (row, Icon, handleAssetClick) => {
    const { key, title } = row;

    const {
      i18n: { messages },
    } = this.props;

    return (
      <NavigationListItem label={messages['app.faq.viewDetails']} tabIndex={-1} onKeyDown={handleAssetClick} testID={key} onClick={ this.props.auth.settingsDisabled? handleAssetClick :handleAssetClick}>
        <div className="profile__item-container" tabIndex={0}>
          <div className="profile__icon">
           <Icon width={30} height={30} color={PALETTE.secondaryActive} secondaryColor={PALETTE.secondaryActive}/>
          </div>
          <Text size="big" id={`${key}_settings`}>{messages[title]}</Text>
        </div>
      </NavigationListItem>
    );
  };

  assetItemWithValue = (row, Icon, handleAssetClick) => {
    const { key, title } = row;

    const {
      i18n: { messages },
      auth: { destinationCurrency },
      languages: { destLanguage },
    } = this.props;
    const currentCurrency = destinationCurrency || messages['app.profile.currency.default'];
    const currentLanguage = destLanguage || 'English';

    return (
      <NavigationListItem label={messages['app.faq.viewDetails']} testID={key} onKeyDown={handleAssetClick} onClick={handleAssetClick} tabIndex={-1}>
        <div className="profile__item-with-value-container" tabIndex={0}>
          <div className="profile__item-container">
            <div className="profile__icon">
              <Icon width={30} height={30} color={'#ffffff'} />
            </div>
            <Text size="big" id={`${key}_preferences`}>{messages[title]}</Text>
          </div>
          <div className="profile__actions-container">
            {key === 'manageDefaultCurrency' && <Text size="big" secondary>{currentCurrency}</Text>}
            {key === 'manageDefaultLanguage' && <Text size="big" secondary>{currentLanguage}</Text>}
          </div>
        </div>
      </NavigationListItem>
    );
  }

  modalContent = () => {
    const {
      i18n: { messages },
      screen,
      buttonToggle,
      loadingFlag,
      submitStarRating,
      skipFeedback
    } = this.props;

    return (
      <div className="popup">
        <div className="starrating-container callout large-8">
          <div className="text-center margin-bottom-30">
            <H3 style={styles.headline}>{messages['app.rating.header']}</H3>
          </div>
          <div className="text-center message-text">
            <Large style={[styles.message, styles.messageWrapper]}>
              {messages['app.rating.subTitle']}
            </Large>
          </div>
          {this.renderStars()}
          {loadingFlag && <LoadingCircle />}
          <div className="text-center">
            <div className="margin-top-10">
              <div style={{ width: 200, margin: '0 auto' }}>
                <Button
                  size="header3"
                  title={messages['app.rating.submit']}
                  onPress={submitStarRating}
                  disabled={buttonToggle}
                />
              </div>
              <div className="skipLink">
                <Button
                  inline
                  title={messages['app.rating.skipFeedback']}
                  size={screen.isSmall ? 'header4' : 'header3'}
                  onPress={skipFeedback}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  goToConsolidationSteup = (e) => {
    const {
      portfolioCount,
      i18n: { messages },
    } = this.props;
    if(isEnterorSpaceKeyPressed(e)){
      if (portfolioCount === 1) {
        alert(messages['app.profile.consolidatesetup']);
      } else {
        this.props.rsaChangePage('/profile/consolidation-setup');
      }
    }
  }

  goToSecurity = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.props.rsaChangePage('/profile/security');
    }
  };

  goToPortfolio = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.props.rsaChangePage('/profile/portfolio');
    }
  }

  changePassword = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.rsaChangePage('/profile/change-password');
    }
  };

  notificationSettings = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.rsaChangePage('/profile/notification-setting');
    }
  };

  provideFeedback = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.rsaChangePage('/profile/feedback');
    }
  };

  termsCondition = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.changePage('/profile/terms-condition');
    }
  };

  goToChangePassword = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      if(this.props.isAirLockUpgrade){
        this.props.rsaChangePage('/profile/change-password-settings');
      }else{
        this.props.rsaChangePage('/profile/change-password');
      }
    }
  };

  goToManageCurrency = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.rsaChangePage('/profile/currency-options');
    }
  }

  goToChangeLanguage = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.rsaChangePage('/profile/language-options');
    }
  }

  goToChangeRegion = () => {
    this.props.rsaChangePage('/profile/profile-region');
  }

  goToDocSignSubscription = () => {
    this.props.rsaChangePage('/profile/docsign-subscription');
  };

  goToManageDevices = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.callVascoFlow();
    this.props.changePage('/profile/manage-devices');
    }
  };

  goTomanageContactDetails = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.changePage(ROUTES.PROFILE.USER_BP_LIST_ROUTE);
    this.props.paperless.setIsEdocumentFlow(false);
    }
  };

  goToPaperlessSettings =(e) => {
    if(isEnterorSpaceKeyPressed(e)){
    this.props.paperless.setIsEdocumentFlow(true);
    this.props.changePage(ROUTES.PAPERLESS.PAPERLESS_SETTINGS_ROUTE);
    }
  }

  renderAssetItem(row, e) {
    const { key } = row;

    switch (key) {
      case 'feedback':
        return this.assetItem(row, FeedbackIcon, this.provideFeedback);
      case 'notification':
        return this.assetItem(row, NotificationIcon, this.notificationSettings);
      case 'termsAndConditions':
           return this.assetItem(row, TermsCondition, this.termsCondition);
      case 'security':
        return this.assetItem(row, Protect, this.goToSecurity);
      case 'portfolio':
        return this.assetItem(row, Presentation, this.goToPortfolio);
      case 'changePassword':
        return this.assetItem(row, ChangePassword, this.goToChangePassword);
      case 'manageConsolidatedView':
        return this.assetItem(row, ManageConsolidatedView, this.goToConsolidationSteup);
      case 'manageDefaultCurrency':
        return this.assetItemWithValue(row, SelectCurrency, this.goToManageCurrency);
      case 'manageDefaultLanguage':
        return this.assetItemWithValue(row, AccountLanguage, this.goToChangeLanguage);
      case 'manageESignature':
        return this.assetItem(row, Contract, this.goToDocSignSubscription);
      case 'manageDevices':
        return this.assetItem(row, ManageDevices, this.goToManageDevices);
      case 'contactDetails':
        return this.assetItem(row, ContactIcon, this.goTomanageContactDetails);
      case 'eDocumentSetting':
        return this.assetItem(row, GoPaperless, this.goToPaperlessSettings);
      default:
        return null;
    }
  }

  render() {
    let {
      items,
      app: {config: {isManageContactDetailsEnabled, isEDocumentSettingsEnabled }},
      title,
      auth,
      i18n: { messages },
      feedbackModal
    } = this.props;

    const rowMarkerStyle = { fill: 'transparent' };

    auth.resetInfoMessage();

    if (!auth.entitlement.notification) {
      const index = items.findIndex((asset) => asset.key === 'notification');
      if (index !== -1) {
        items.splice(index, 1);
      }
    }
    if (items && this.props.webssoauthentication.webssoEnabled) {
      const index = items.findIndex(
        (items) => items.key === 'security'
      );
      if (index != -1) {
        items.splice(index, 1);
      }
    }

    if (!auth.entitlement.esign_regular_customer) {
      const esignindex = items.findIndex((asset) => asset.key === 'manageESignature');
      if (esignindex !== -1) {
        items.splice(esignindex, 1);
      }
    }

    //to hide/show manage contact details and edocument settings dynamically - only for CH - WMCE-51093
    if( envConfig.envConfig === EBANKINGWEB || envConfig.rmRegion === RM_REGION_CH ) {
      items= items.filter(function(item) {
        if (item.key === 'contactDetails' && !isManageContactDetailsEnabled){
          return false;
        }
        if (item.key === 'eDocumentSetting' && !isEDocumentSettingsEnabled){
          return false;
        }
        return true;
      });
    }

    // To hide ManageContact Details option in DWO client and RM-Access
    if( envConfig.envConfig != EBANKINGWEB || envConfig.rmRegion != RM_REGION_CH ) {
      items= items.filter(function(item) {
        if (item.key === 'contactDetails' || item.key === 'eDocumentSetting'){
          return false;
        }
        return true;
      });
    }

    return (
      <div className="row large-collapse">
        <div className="columns small-12 large-12  profile-container">
          <div className="profile-container__title">
            <H1 tabIndex={0} className="margin-top-1">{title}</H1>
            {
              title === messages['app.common.pageTitle.settings'] &&
              auth.lastSession &&
              <div className="pad-bottom-10" tabIndex={0}>
                <LastLoginHeader
                  dateValue={format(new Date(auth.lastSession), 'yyyy-MM-dd')}
                  timeValue={auth.lastSession}
                />
              </div>
            }
          </div>
          <div>
            <NavigationList className="settings-list">
              {
                items.map((item) =>
                  this.renderAssetItem(item)
                ).filter((x) => x !== null)
              }
            </NavigationList>
          </div>
        </div>
        {feedbackModal ? (
          <BlurModal
            visible={feedbackModal}
            style={styles.mainWrapper}
            disableDone
          >
            {this.modalContent()}
          </BlurModal>
        ) : null}
      </div>
    );
  }
}

export default ProfileItem;
